export var PatchType = /*#__PURE__*/ function(PatchType) {
    PatchType["ADD"] = "add";
    PatchType["REPLACE"] = "replace";
    PatchType["DELETE"] = "delete";
    return PatchType;
}({});
export var ParserMode = /*#__PURE__*/ function(ParserMode) {
    ParserMode[ParserMode["INITIAL_FULL_MPD"] = 0] = "INITIAL_FULL_MPD";
    ParserMode[ParserMode["PATCH_MPD"] = 1] = "PATCH_MPD";
    return ParserMode;
}({});
export var ParserAction = /*#__PURE__*/ function(ParserAction) {
    ParserAction[ParserAction["CACHE"] = 0] = "CACHE";
    ParserAction[ParserAction["PROCESS"] = 1] = "PROCESS";
    return ParserAction;
}({});

//# sourceMappingURL=dash-patcher-mpd.enums.js.map